import _ from "lodash";
import {i18n} from 'i18next';

const monthList = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
];

export function addKendoLocale(i18n: i18n) {
    const { t, exists } = i18n;
    const isEn = i18n.language == 'en-US';
    function td(key: string, def: string) {
        return exists(key) ? t(key) : def;
    }
    const en = kendo.cultures['en-US'];
    const currentLang = _.cloneDeep(en);
    kendo.cultures['tilzone'] = currentLang;
    if (currentLang.calendar) {
        const short = currentLang.calendar.days.namesShort.map(x => x.toLowerCase());
        currentLang.calendar.days.names = short.map(x => t('weekdayfull.' + x));
        currentLang.calendar.days.namesAbbr = short.map(x => t('weekdayshort.' + x));
        currentLang.calendar.days.namesShort = short.map(x => t('weekdayshort.' + x));
        currentLang.calendar.months.names = monthList.map(x => td('month.names.' + x, x));
        currentLang.calendar.months.namesAbbr = monthList.map(x => x.substring(0, 3)).map(x => td('month.short.' + x, x));
        currentLang.calendar.firstDay = isEn ? 0 : 1;
    }
    kendo.culture('tilzone');
}
